import * as utility from '../misc/utility';
import { CeremonyDetails, CeremonyInfo } from '../objects/Ceremony';

/**
 * @typedef { import('./ApiService').ApiService } ApiService
 */

export class CeremonyEndpoint {
    /**
     * 
     * @param {string} url
     * @param {ApiService} api
     */
    constructor(url, api) {
        this.url = url;
        this._api = api;
    }

    getCeremony(id) {
        if (!utility.isGuid(id)) throw "Invalid parameter, expected GUID";

        var dst = this.url + '/' + encodeURIComponent(id);
        return this._api.getResponse(dst)
            .then(rsp => rsp.parseSingleResult(CeremonyDetails.mapResponse));
    }

    getCeremonies(criteria) {
        var dst = this.url + '/search';
        return this._api.postResponse(dst, criteria)
            .then(rsp => rsp.parseListResult(CeremonyInfo.mapResponse));
    }

    attachCeremony(id, cmd) {
        if (!utility.isGuid(id)) throw "Invalid parameter, expected GUID";

        var dst = this.url + '/' + encodeURIComponent(id) + '/attach';
        return this._api.postResponse(dst, cmd)
            .then(rsp => rsp.getResult());
    }

    convertCeremony(id, cmd) {
        if (!utility.isGuid(id)) throw "Invalid parameter, expected GUID";

        var dst = this.url + '/' + encodeURIComponent(id) + '/convert';
        return this._api.postResponse(dst, cmd)
            .then(rsp => rsp.getResult());
    }

    rejectCeremony(id, cmd) {
        if (!utility.isGuid(id)) throw "Invalid parameter, expected GUID";

        var dst = this.url + '/' + encodeURIComponent(id) + '/reject';
        return this._api.postVoid(dst, cmd);
    }
}

